import {CallListQuery} from "@/components/call-list/queries.generated";

export enum TimeRange {
    Today = "today",
    Yesterday = "yesterday",
    ThisWeek = "this-week",
    PreviousWeek = "previous-week",
    Month = "month",
}

export type Call = CallListQuery["callList"]["calls"][number];

/// an incoming queue call associated with its agent calls
export interface QueueCall {
    received: Call;
    agent: Call[];
}
